<div *ngIf="pageInfo" class="mid-right" [ngClass]="{'blur-content': blurOn}">
  
  
    <ng-container *ngIf="pageInfo.PageCount > 1">
      <div class="d-flex gap-2">
        <div class="btn-group me-2" role="group">
          <button
            ngDefaultControl
            [disabled]="pageInfo.IsFirstPage ? true : false"
            type="button"
            class="btn btn-outline-secondary"
            (click)="firstPage()"
          >
            <i class="bx bx-first-page"></i>
          </button>
          <button
            ngDefaultControl
            [disabled]="pageInfo.IsFirstPage ? true : false"
            type="button"
            class="btn btn-outline-secondary"
            (click)="previousPage()"
            >
            Geri
          </button>
          <!--select name="pager" id="pager" class="page-number hide-arrow text-secondary d-inline border border-secondary border-start-none" [(ngModel)]="pageRequest.pageIndex" (ngModelChange)="getByNumber($event)" >
              <option class="text-center page-number-option" *ngFor="let value of buttonValues" [value]="value"> {{value}} </option>
            </select-->
            <input type="text" [min]="1" [max]="pageInfo.PageCount" [ngModel]="pageRequest.pageIndex" 
            (ngModelChange)="onPageInputChange($event)"
  class="page-number hide-arrow text-secondary d-inline border border-secondary border-start-none text-center" />
          <button
            ngDefaultControl
            [disabled]="pageInfo.IsLastPage ? true : false"
            type="button"
            class="btn btn-outline-secondary"
            (click)="nextPage()"
            >
            İleri
          </button>
          <button
            ngDefaultControl
            [disabled]="pageInfo.IsLastPage ? true : false"
            type="button"
            class="btn btn-outline-secondary"
            (click)="lastPage()"
          >
            <i class="bx bx-last-page"></i>
          </button>
        </div>
      <div class="align-items-center d-flex px-2 border border-primary rounded-2 text-primary">
        {{pageRequest.pageIndex}} / {{ pageInfo.PageCount }}
      </div>
    </div>
  </ng-container>

  <div *ngIf="pageInfo.TotalItemCount > 0" class="right-item d-flex align-items-center gap-2"> 
    <div class="btn-group" role="group" *ngIf="displayViewChange">
      <button type="button" class="btn btn-sm" [ngClass]="showAsGrid ? 'btn-outline-primary' : 'btn-primary'" (click)="changeView(false)">
        <i class="fas fa-table"></i>
      </button>
      <button type="button" class="btn btn-sm" [ngClass]="showAsGrid ? 'btn-primary' : 'btn-outline-primary'" (click)="changeView(true)">
        <i class="fas fa-list"></i>
      </button>
    </div>
    <button *ngIf="exportable" type="button" class="btn btn-sm btn-success" [ngClass]="" (click)="export()">
      <i class="fas fa-file-excel"></i>
    </button>
    <span class="fs-6" >{{pageInfo.TotalItemCount}} </span>
    <span class="text-muted"> kayıttan </span>  
    <select class="item-count hide-arrow text-center border-none " name="pager" id="pager" [(ngModel)]="pageRequest.itemPerPage" (ngModelChange)="setItemPerPage()">
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </select> <span class="text-muted">  kayıt göster </span>
  </div>
</div>
